import * as BABYLON from "babylonjs";
export class Scene  extends BABYLON.Scene{
    constructor(engine) {
        super(engine)
        this.clearColor = new BABYLON.Color4(0,0,0,0)
        this.useRightHandedSystem = true
        // this.fogMode =BABYLON.Scene.FOGMODE_NONE;
        this.fogMode =BABYLON.Scene.FOGMODE_LINEAR;
        // this.fogMode =BABYLON.Scene.FOGMODE_EXP2;
        // this.fogMode =BABYLON.Scene.FOGMODE_EXP;
        this.fogColor = new BABYLON.Color3(1, 1, 1);
        // this.fogDensity = 0.003
        this.fogStart = 300
        this.fogEnd = 400
        //https://playground.babylonjs.com/#HH8T00#1 skybox
        //https://playground.babylonjs.com/#11GAIH#17
        
    }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Scene.js